<template>
  <div id="featuredNews-vue-test">
   
  <!-- <h1> {{$root.language.wsm_featuredNewsHeadline}}</h1> -->
    <featuredNewsList/>    
    
  </div>
</template>

<script>
import featuredNewsList from './components/featuredNewsList.vue'


export default {
  name: 'FeaturedNews',
  components: {
   featuredNewsList   
  }

}
</script>

<style scoped>
h1{
  margin:20px 0;
}
#featuredNews-vue-test{
  margin-bottom: 1em;
}
</style>
